import React from 'react'
import FilterItems from '../../../../AppViews/Products/components/Filter'
import { CreateNFeContext } from '../Context'
import Text from "../../../../../_components/Text"
import Button from "../../../../../_components/Button"
import Modal from "../../../../../_components/Modal"
import List from './list'
import CheckBox from '../../../../../_components/Checkbox'
import { formatCurrencyValue } from '../../../../../utils'
import { getBranchOwner } from '@config'
import { toast } from "react-toastify";

import Row from '../../../../../_components/Layout/Row'
import Column from '../../../../../_components/Layout/Column'

export default () => {
    const context = React.useContext(CreateNFeContext)
    const [show, showModal] = React.useState(false)
    const [stackable, changeStackable] = React.useState(false)

    const branch = getBranchOwner()

    function handleAddItem(item) {
        const { addNFeItem } = context.handlers;
        addNFeItem(item, stackable);

        const isCST = branch.crt === 3 || branch.crt === 2;

        // regime normal e simples nacional excesso de sublimite (CRT = 2 ou 3)
        if (isCST && (!item.icms.cst || item.icms.cst === null || item.icms.cst === '')) {
            toast.error(
                <Text color="white">O produto cadastrado possui CSOSN/CST inválido para o CRT cadastrado</Text>, {
                position: "top-center",
                toastId: "error-product-without-description"
            });
        }

        // Simples Nacional e Mei (CRT diferente de 2 e 3)
        if (!isCST && (item.icms.cst !== null && item.icms.cst !== '')) {
            toast.error(
                <Text color="white">O produto cadastrado possui CSOSN/CST inválido para o CRT cadastrado</Text>, {
                position: "top-center",
                toastId: "error-product-without-description"
            });
        }

        showModal(false);
    }


    if (context.step != "items") {
        return <React.Fragment />
    }

    return <React.Fragment>
        <Row>
            <Column col="12">
                <CheckBox
                    onClick={() => {
                        if (stackable == true) {
                            changeStackable(false)
                        }
                        else { changeStackable(true) }
                    }}
                    checked={stackable}
                    title="Quando marcado, produtos iguais adicionados somarão em 1 (um) a quantidade do produto."
                    label="Separar produtos iguais?"
                />
            </Column>
        </Row>

        <div className="d-flex py-1 justify-content-center">
            <Button
                data-cy-test="#nfe-issuer-button-open-modal-search-itens"
                onClick={() => showModal(true)}>
                <Text className="text-white">
                    Adicionar Item <i className="fa fa-plus" />
                </Text>
            </Button>
        </div>
        {
            context.nfe.items.length
                ? <div>
                    <List />
                </div>
                : <div className="alert alert-primary">
                    <Text className="text-center" as="h4">
                        Nenhum item na nota
                    </Text>
                </div>
        }
        <Text fontSize="1.2em" align="right">
            Total: {formatCurrencyValue(context.nfe.total_items || 0)}
        </Text>
        <Modal title="Pesquisar item" show={show} onHide={() => showModal(false)}>
            <FilterItems modalBehavior onClick={handleAddItem} />
        </Modal>
    </React.Fragment>
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/Items/index.jsx